import {
  Autocomplete,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  ListItemText,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import * as _ser from "../../_redux/_services/ProjectsSlice";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import CkEditor from "../../components/CkEditor/CkEditor";
import "./ProjectsEdit/projects_edit.css";

import { GetUserId, getAttributes } from "../../_utilities/getUserInfo";
import { defaultApplicantsData } from "../../_utilities/defaultfieldsModel";
const initalState = { data: null, message: "", isloader: true };

const initialDetails = {
  id: null,
  projectCode: "",
  name: "",
  internalVisibility: "",
  selectedStatuses: [],
  allowedMembers: [],
  externalAccess: "",
  authorizedExternalUsers: [],
  hideContactInfo: false,
  hideDocuments: true,
  isNotesVisible: false,
  isApplicantStatusEnabled: false,
  description: "",
  createdBy: "",
  status: null,
  userId: "",
  token: "",
};

const initProjects = JSON.parse(JSON.stringify(initialDetails));
const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;

const externalUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .matches(nameRegex, "Enter a valid first name")
    .required("First name is required"),
  lastName: Yup.string()
    .trim()
    .matches(nameRegex, "Enter a valid last name")
    .required("Last name is required"),
  emailId: Yup.string()
    .trim()
    .email("Invalid email format")
    .required("Email ID is required"),
});

const ProjectsComponent = ({
  componentType = "view",
  actions,
  onValidData,
  input,
  disableBtn = false,
  headerAction,
}) => {
  const dispatch = useDispatch();
  const [projects, setProjects] = useState(initialDetails);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(disableBtn);
  const [projectDescriptionValue, setProjectDescriptionValue] = useState("");
  const [isVisibility, setIsVisibility] = useState(false);
  const [isDescriptionError, setIsDescriptionError] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);

  const [extUser, setExtUser] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
  });
  const [extUserErrors, setExtUserErrors] = useState({});
  const [editingExtUserIndex, setEditingExtUserIndex] = useState(null);

  const navigate = useNavigate();

  const customFieldsData = useSelector((state) => state.CustomFields?.data);

  useEffect(() => {
    if (input !== undefined && input !== null) {
      const mappedInput = { ...input };

      if (input.visibility === "public") {
        mappedInput.internalVisibility = "organization-wide";
      } else {
        mappedInput.internalVisibility = input.visibility;
      }

      mappedInput.allowedMembers = Array.isArray(input.accessibleTo)
        ? input.accessibleTo
        : typeof input.accessibleTo === "string"
          ? JSON.parse(input.accessibleTo) || []
          : [];

      if (input.externalAccessType === "RESTRICTED") {
        mappedInput.externalAccess = "restricted-link-access";
      } else if (input.externalAccessType === "OPEN") {
        mappedInput.externalAccess = "open-link-access";
      } else if (input.externalAccessType === "DISABLED") {
        mappedInput.externalAccess = "disabled";
      } else {
        mappedInput.externalAccess = "disabled";
      }

      mappedInput.authorizedExternalUsers = input.externalPortalUsers || [];
      mappedInput.hideContactInfo =
        input.hideContactInfo === "1" ||
        input.hideContactInfo === true ||
        input.hideContactInfo === 1;
      mappedInput.isNotesVisible = input.isNotesVisible?.toString() === "1" || input.isNotesVisible === true;
      mappedInput.isApplicantStatusEnabled = input.isApplicantStatusEnabled?.toString() === "1" || input.isApplicantStatusEnabled === true;
      mappedInput.token = input.token || "";
      let statusesForEdit = [];
      if (!input.applicantStatus?.trim()) {
        statusesForEdit = candidateStatusValues.map((x) => String(x.internal));
      } else {
        const selectedIds = input.applicantStatus.split(",").map((s) => s.trim());
        statusesForEdit = candidateStatusValues
          .filter((x) => selectedIds.includes(x.internal))
          .map((x) => String(x.internal));
      }
      mappedInput.applicantStatus = statusesForEdit;
      setSelectedStatuses(statusesForEdit);
      if (componentType === "edit") {
        formik.setValues({
          ...formik.values,
          name: mappedInput.name,
          description: mappedInput.description,
          internalVisibility: mappedInput.internalVisibility,
          allowedMembers: mappedInput.allowedMembers,
          externalAccess: mappedInput.externalAccess,
          authorizedExternalUsers: mappedInput.authorizedExternalUsers,
          hideContactInfo: mappedInput.hideContactInfo,
          isNotesVisible: mappedInput.isNotesVisible,
          isApplicantStatusEnabled: mappedInput.isApplicantStatusEnabled,
          token: mappedInput.token,
          selectedStatuses: statusesForEdit,
        });
      }
      setProjectDescriptionValue(mappedInput.description);
      setIsVisibility(mappedInput.internalVisibility !== "organization-wide");
      setProjects(mappedInput);
    }
  }, [input, candidateStatusValues]);

  useEffect(() => {
    console.log("projects", projects);
  }, [projects]);

  const AccessibleTeams = useSelector((state) => state.GetAccessibleTo.data);

  useEffect(() => {
    const init = async () => {
      const userId = await GetUserId();
      dispatch(_ser.getAccessibleToAsync(userId));
    };
    init();
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(1, "Must be 1 characters")
      .max(50, "Must be less than 50 ")
      .required("Please enter a project's name"),
    internalVisibility: Yup.string().required(
      "Please select internal visibility",
    ),
    allowedMembers: Yup.array().when("internalVisibility", {
      is: (val) => val === "restricted",
      then: (schema) =>
        schema.min(1, "Allowed Members is required for restricted visibility"),
      otherwise: (schema) => schema.notRequired(),
    }),
    externalAccess: Yup.string().required("Please select external access"),
    description: Yup.string()
      .test(
        "not-empty",
        "Description is required. Please provide a description",
        (value) => !isEmptyDescription(value),
      )
      .required(),
    selectedStatuses: Yup.array()
      .min(1, "Please select at least one applicant status")
      .required("Please select at least one applicant status"),
  });

  const formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initProjects)),
    validationSchema,
    validate: async (values) => {
      setIsDescriptionError(values.description ? false : true);
    },
    onSubmit: async (values) => {
      if (!selectedStatuses || selectedStatuses.length === 0) {
        formik.setFieldError(
          "selectedStatuses",
          "Please select at least one applicant status",
        );
        formik.setFieldTouched("selectedStatuses", true, false);
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one applicant status.",
          }),
        );
        setDisableSubmitBtn(false);
        return;
      }
      let currentUsersLocal = [...(projects.authorizedExternalUsers || [])];

      // If the user has typed a valid entry but hasn't clicked "Add Row", add it so validation passes
      if (projects.externalAccess === "restricted-link-access") {
        if (extUser.firstName || extUser.lastName || extUser.emailId) {
          try {
            await externalUserSchema.validate(extUser, { abortEarly: false });
            currentUsersLocal.push(extUser);
            // Also update state silently without triggering immediate re-renders since we're about to submit
            onChangeHandler(currentUsersLocal, "authorizedExternalUsers");
            setExtUser({ firstName: "", lastName: "", emailId: "" });
            setExtUserErrors({});
            setEditingExtUserIndex(null);
          } catch (err) {
            if (err.inner) {
              const errors = {};
              err.inner.forEach((validationError) => {
                errors[validationError.path] = validationError.message;
              });
              setExtUserErrors(errors);
              setDisableSubmitBtn(false);
              return; // Stop the save process because of the invalid draft
            }
          }
        }
      }

      if (componentType === "edit") {
        if (
          projects.externalAccess === "restricted-link-access" &&
          (!currentUsersLocal || currentUsersLocal.length === 0)
        ) {
          dispatch(
            updateSnackbar({
              type: "error",
              message:
                "Add at least one authorized external user to enable Restricted Link Access.",
            }),
          );
          return;
        }
        const attributes = await getAttributes();
        let userString = `${attributes[0].id}@${attributes[0]?.firstName} ${attributes[0]?.lastName}`;

        values.id = projects?.id;
        values.description = projectDescriptionValue;
        values.userId = projects?.userId;
        values.status = projects.status;
        values.applicantStatus =
          candidateStatusValues.length > 0 &&
            selectedStatuses.length === candidateStatusValues.length
            ? " "
            : selectedStatuses.join(",");
        values.visibility =
          projects.internalVisibility === "organization-wide"
            ? "public"
            : projects.internalVisibility;
        values.accessibleTo = JSON.stringify(
          projects.internalVisibility === "restricted"
            ? projects.allowedMembers
            : [userString],
        );
        values.hideContactInfo = projects.hideContactInfo ? "1" : "0";
        values.isNotesVisible = projects.isNotesVisible ? 1 : 0;
        values.isApplicantStatusEnabled = projects.isApplicantStatusEnabled ? 1 : 0;
        values.hideDocuments = projects.hideContactInfo
          ? projects.hideDocuments
            ? "1"
            : "0"
          : "0";
        values.externalAccessType =
          projects.externalAccess === "restricted-link-access"
            ? "RESTRICTED"
            : projects.externalAccess === "open-link-access"
              ? "OPEN"
              : "DISABLED";
        values.users = currentUsersLocal.map((u) => ({
          firstName: u.firstName,
          lastName: u.lastName,
          email: u.emailId || u.email,
        }));

        setDisableSubmitBtn(true);
        await onValidData(values);
      }
    },
  });

  const code = useSelector((state) => state.EditProjects.data);

  useEffect(() => {
    if (code === 200) {
      dispatch(_ser.editProjectsStartReducer(initalState));
      navigate("/ats/layout/projects/landing");
    }
  }, [code]);

  const onChangeHandler = (value, type) => {
    let obj = JSON.parse(JSON.stringify(projects));
    if (type === "internalVisibility" && value !== "restricted") {
      obj.allowedMembers = [];
      formik.values.allowedMembers = [];
    }
    if (type === "externalAccess") {
      if (value !== "restricted-link-access") {
        obj.authorizedExternalUsers = [];
        formik.values.authorizedExternalUsers = [];
      }
      if (value !== "restricted-link-access" && value !== "open-link-access") {
        obj.hideContactInfo = false;
        formik.values.hideContactInfo = false;
      }
      obj.isNotesVisible = false;
      obj.isApplicantStatusEnabled = false;
      formik.values.isNotesVisible = false;
      formik.values.isApplicantStatusEnabled = false;
    }
    if (type === "hideContactInfo") {
      if (value) {
        obj.hideDocuments = true;
        formik.values.hideDocuments = true;
      }
    }
    obj[type] = value;
    setProjects(obj);
    formik.setFieldValue(type, value, true);
  };

  const handleAddExternalUser = async () => {
    try {
      setExtUserErrors({});
      await externalUserSchema.validate(extUser, { abortEarly: false });

      const updatedUsers = [...(projects.authorizedExternalUsers || [])];

      if (editingExtUserIndex !== null) {
        updatedUsers[editingExtUserIndex] = extUser;
        setEditingExtUserIndex(null);
      } else {
        updatedUsers.push(extUser);
      }

      onChangeHandler(updatedUsers, "authorizedExternalUsers");
      handleClearExternalUserInput();
    } catch (err) {
      if (err.inner) {
        const errors = {};
        err.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
        setExtUserErrors(errors);
      }
    }
  };

  const handleClearExternalUserInput = () => {
    setExtUser({ firstName: "", lastName: "", emailId: "" });
    setExtUserErrors({});
    setEditingExtUserIndex(null);
  };

  // const handleEditExternalUser = (index) => {
  //   const userToEdit = projects.authorizedExternalUsers[index];
  //   setExtUser({ ...userToEdit });
  //   setEditingExtUserIndex(index);
  // };

  const handleRemoveExternalUser = (index) => {
    const updatedUsers = projects.authorizedExternalUsers.filter(
      (_, i) => i !== index,
    );
    onChangeHandler(updatedUsers, "authorizedExternalUsers");
    if (editingExtUserIndex === index) {
      handleClearExternalUserInput();
    }
  };

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Candidate status") {
          setCandidateStatusValues(list.customValues || []);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customStatusFieldsData = data.filter(
        (x) =>
          x.moduleId.toString() === "2" &&
          x.fieldType === "default" &&
          x.fieldName === "Candidate status",
      );
      if (customStatusFieldsData.length > 0) {
        let index = customStatusFieldsData.length - 1;
        let val = customStatusFieldsData[index].customValues;
        let array = typeof val === "string" ? JSON.parse(val) : val;
        setCandidateStatusValues(array);
      }
    }
  }, [customFieldsData]);

  const handleCopyLink = async () => {
    const url = `${process.env.REACT_APP_JOBBOARD_PORTAL_URL}${projects?.token || ""}`;
    navigator.clipboard.writeText(url);
    try {
      await navigator.clipboard.writeText(url);
      dispatch(
        updateSnackbar({
          type: "success",
          message: "Project URL copied to clipboard!",
        }),
      );
    } catch {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Failed to copy URL",
        }),
      );
    }
  };

  const onDesciptionHandler = (value) => {
    const empty = isEmptyDescription(value);
    formik.setFieldValue("description", empty ? "" : value, true);
    setProjectDescriptionValue(value);
    setIsDescriptionError(empty);
  };

  const isEmptyDescription = (value) => {
    if (!value) return true;

    const text = value
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();
    return text.length === 0;
  };

  return (
    <>
      {projects && (
        <>
          <div className="actionBtnRtl">
            {headerAction && headerAction}
            {actions &&
              actions.map((item) => {
                if (item.type === "back") {
                  return (
                    <Button
                      variant={item.variant}
                      className={item.class}
                      style={item.style}
                      size="small"
                      onClick={() => navigate(item.navigateTo)}
                    >
                      {componentType !== "view" ? (
                        <Link
                          href="#"
                          style={{ color: "red", fontSize: "14px" }}
                          underline="always"
                        >
                          {item.label}{" "}
                        </Link>
                      ) : (
                        <>{item.label} </>
                      )}
                    </Button>
                  );
                } else if (item.type === "submit") {
                  return (
                    <Button
                      variant={item.variant}
                      className={item.class}
                      style={item.style}
                      size="small"
                      disabled={disableSubmitBtn}
                      onClick={formik.handleSubmit}
                    >
                      {item.label}{" "}
                    </Button>
                  );
                }
              })}
          </div>

          <FocusError formik={formik} />
          <div
            style={{ height: "100%" }}
            className={componentType === "view" ? "viewSection" : ""}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "wrap",
                marginTop: "60px",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "32%" }}>
                <TextField
                  className="boldlabel"
                  error={
                    formik.errors.name && formik.touched.name ? true : false
                  }
                  helperText={
                    formik.errors.name && formik.touched.name
                      ? formik.errors.name
                      : ""
                  }
                  autoFocus={formik.errors.name !== "" ? true : false}
                  id="outlined-basic"
                  variant="outlined"
                  autoComplete="off"
                  label="Project Name*&nbsp;"
                  style={{ width: "100%" }}
                  name="name"
                  value={projects.name ? projects.name : ""}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeHandler(e.target.value, "name")}
                  onKeyUp={formik.handleBlur}
                  disabled={componentType !== "view" ? false : true}
                />
              </div>

              <div style={{ width: "32%" }}>
                <TextField
                  className="viewSection label"
                  id="outlined-basic"
                  variant="outlined"
                  autoComplete="off"
                  label="Created by&nbsp;"
                  style={{ width: "100%" }}
                  name="createdBy*"
                  value={projects.createdBy ? projects.createdBy : ""}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeHandler(e.target.value, "createdBy")}
                  disabled={true}
                />
              </div>
              <div style={{ width: "32%" }}>
                <FormControl fullWidth>
                  <InputLabel className="boldSelectlabel" shrink={true}>
                    Project Status&nbsp;
                  </InputLabel>
                  <Select
                    value={projects.status}
                    name="status"
                    disabled={componentType === "view" ? true : false}
                    label="Project Status &nbsp;&nbsp;"
                    onChange={(e) => onChangeHandler(e.target.value, "status")}
                    autoComplete="off"
                    style={{
                      width: "100%",
                      height: "3.5rem",
                      borderRadius: "4px",
                    }}
                  >
                    {statusArray &&
                      statusArray?.map((list) => {
                        return (
                          <MenuItem key={list.id} value={list.id}>
                            {list.title}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexFlow: "wrap",
                marginTop: "40px",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "32%" }}>
                <FormControl
                  fullWidth
                  error={
                    formik.errors.internalVisibility &&
                      formik.touched.internalVisibility
                      ? true
                      : false
                  }
                >
                  <InputLabel className="boldSelectlabel" shrink={true}>
                    Internal Visibility*&nbsp;
                  </InputLabel>
                  <Select
                    value={
                      projects.internalVisibility
                        ? projects.internalVisibility
                        : ""
                    }
                    name="internalVisibility"
                    disabled={componentType === "view" ? true : false}
                    label="Internal Visibility &nbsp;&nbsp;"
                    onChange={(e) =>
                      onChangeHandler(e.target.value, "internalVisibility")
                    }
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                    style={{
                      width: "100%",
                      height: "3.5rem",
                      borderRadius: "4px",
                    }}
                  >
                    {internalVisibilityArray &&
                      internalVisibilityArray?.map((list) => {
                        return (
                          <MenuItem key={list.id} value={list.name}>
                            {list.title}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  <FormHelperText>
                    {formik.errors.internalVisibility &&
                      formik.touched.internalVisibility
                      ? formik.errors.internalVisibility
                      : ""}
                  </FormHelperText>
                </FormControl>
              </div>

              <div style={{ width: "32%" }}>
                <FormControl
                  sx={{ width: "100%" }}
                  fullWidth
                  error={
                    formik.errors.allowedMembers &&
                      formik.touched.allowedMembers
                      ? true
                      : false
                  }
                >
                  <InputLabel
                    className="boldSelectlabel"
                    id="demo-multiple-chip-label"
                    shrink={true}
                  >
                    Allowed Members*
                  </InputLabel>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    limitTags={2}
                    options={AccessibleTeams || []}
                    getOptionLabel={(option) => option.fullName || ""}
                    value={
                      AccessibleTeams?.filter((item) =>
                        projects.allowedMembers?.includes(
                          item.id + "@" + item.fullName,
                        ),
                      ) || []
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    disabled={
                      componentType === "view" ||
                      projects.internalVisibility !== "restricted"
                    }
                    onChange={(event, value) => {
                      const vals = value.map(
                        (item) => item.id + "@" + item.fullName,
                      );
                      onChangeHandler(vals, "allowedMembers");
                    }}
                    onBlur={() =>
                      formik.setFieldTouched("allowedMembers", true)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        error={
                          formik.errors.allowedMembers &&
                            formik.touched.allowedMembers
                            ? true
                            : false
                        }
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={option?.fullName}
                          {...getTagProps({ index })}
                          key={option.id}
                        />
                      ))
                    }
                  />
                  <FormHelperText>
                    {formik.errors.allowedMembers &&
                      formik.touched.allowedMembers
                      ? formik.errors.allowedMembers
                      : ""}
                  </FormHelperText>
                </FormControl>
              </div>

              <div style={{ width: "32%" }}>
                <FormControl
                  fullWidth
                  error={
                    formik.errors.externalAccess &&
                      formik.touched.externalAccess
                      ? true
                      : false
                  }
                >
                  <InputLabel className="boldSelectlabel" shrink={true}>
                    External Access*&nbsp;
                  </InputLabel>
                  <Select
                    value={projects.externalAccess || ""}
                    name="externalAccess"
                    disabled={componentType === "view" ? true : false}
                    label="External Access &nbsp;&nbsp;"
                    onChange={(e) =>
                      onChangeHandler(e.target.value, "externalAccess")
                    }
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                    style={{
                      width: "100%",
                      height: "3.5rem",
                      borderRadius: "4px",
                    }}
                  >
                    {externalAccessArray &&
                      externalAccessArray?.map((list) => {
                        return (
                          <MenuItem key={list.id} value={list.name}>
                            {list.title}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  <FormHelperText>
                    {formik.errors.externalAccess &&
                      formik.touched.externalAccess
                      ? formik.errors.externalAccess
                      : ""}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "50px",
                width: "100%",
              }}
            >
              <FormControl
                fullWidth
                error={
                  formik.errors.description &&
                    formik.touched.description &&
                    isDescriptionError === true
                    ? true
                    : false
                }
              >
                <InputLabel
                  style={{
                    marginTop: "-50px",
                    marginLeft: "-13px",
                    background: "none",
                  }}
                  className={
                    formik.errors.description &&
                      formik.touched.description &&
                      isDescriptionError
                      ? "text-danger boldSelectlabel"
                      : "boldSelectlabel"
                  }
                >
                  Project Description*
                </InputLabel>
                <div
                  id="projectDesc"
                  className={
                    formik.errors.description &&
                      formik.touched.description &&
                      isDescriptionError
                      ? "brd-danger"
                      : ""
                  }
                >
                  <CkEditor
                    data={
                      projectDescriptionValue && projectDescriptionValue === ""
                        ? " "
                        : projectDescriptionValue
                    }
                    error={
                      formik.errors.description &&
                      formik.touched.description &&
                      isDescriptionError === true
                    }
                    name="description"
                    autoComplete="off"
                    isReadonly={componentType === "view" ? true : false}
                    onUpdatehandler={(update) => {
                      onDesciptionHandler(update.data);
                    }}
                  />
                </div>
                {formik.errors.description &&
                  formik.touched.description &&
                  isDescriptionError ? (
                  <FormHelperText className="text-danger">
                    Description is required. Please provide a description
                  </FormHelperText>
                ) : (
                  ""
                )}
              </FormControl>
            </div>

            {(projects.externalAccess === "restricted-link-access" ||
              projects.externalAccess === "open-link-access") && (
                <div
                  className="hide-contact-info-section"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <span className="boldTextlabel" style={{width: "300px"}}>
                    Hide Applicant Contact Information :
                  </span>
                  <RadioGroup
                    row
                    name="hideContactInfo"
                    value={projects.hideContactInfo ? "yes" : "no"}
                    onChange={(e) =>
                      onChangeHandler(e.target.value === "yes", "hideContactInfo")
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          disabled={componentType === "view" ? true : false}
                          size="small"
                          sx={{
                            "&.Mui-checked": {
                              color: "var(--primary-bg-color)",
                            },
                          }}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          disabled={componentType === "view" ? true : false}
                          size="small"
                          sx={{
                            "&.Mui-checked": {
                              color: "var(--primary-bg-color)",
                            },
                          }}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </div>
              )}
            {projects.hideContactInfo && (
              <>
                <div
                  className="hide-contact-info-section"
                  style={{
                    marginBottom: "0px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <span className="boldTextlabel" style={{width: "300px"}}>Hide Resume :</span>
                  <RadioGroup
                    row
                    name="hideDocuments"
                    value={projects.hideDocuments ? "yes" : "no"}
                    onChange={(e) =>
                      onChangeHandler(e.target.value === "yes", "hideDocuments")
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          disabled={componentType === "view" ? true : false}
                          size="small"
                          sx={{
                            "&.Mui-checked": {
                              color: "var(--primary-bg-color)",
                            },
                          }}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          disabled={componentType === "view" ? true : false}
                          size="small"
                          sx={{
                            "&.Mui-checked": {
                              color: "var(--primary-bg-color)",
                            },
                          }}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </div>
                {projects.hideDocuments === false &&
                  componentType !== "view" && (
                    <span
                      style={{
                        textAlign: "left",
                        color: "#d32f2f",
                      }}
                    >
                      If the resume contains contact information (such as email
                      or phone number), it will remain visible and cannot be
                      automatically hidden.
                    </span>
                  )}
              </>
            )}
            {(projects.externalAccess === "restricted-link-access") && (
                <>
                    <div
                    className="hide-contact-info-section"
                    style={{
                      marginTop: "30px",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <span className="boldTextlabel" style={{width: "300px"}}>
                      Enable Notes Section :
                    </span>
                    <RadioGroup
                      row
                      name="isNotesVisible"
                      value={projects.isNotesVisible ? "yes" : "no"}
                      onChange={(e) =>
                        onChangeHandler(e.target.value === "yes", "isNotesVisible")
                      }
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Radio
                            disabled={componentType === "view" ? true : false}
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "var(--primary-bg-color)",
                              },
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={
                          <Radio
                            disabled={componentType === "view" ? true : false}
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "var(--primary-bg-color)",
                              },
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                  <div
                    className="hide-contact-info-section"
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <span className="boldTextlabel" style={{width: "300px"}}>
                      Update Status on every submission:
                    </span>
                    <RadioGroup
                      row
                      name="isApplicantStatusEnabled"
                      value={projects.isApplicantStatusEnabled ? "yes" : "no"}
                      onChange={(e) =>
                        onChangeHandler(e.target.value === "yes", "isApplicantStatusEnabled")
                      }
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Radio
                            disabled={componentType === "view" ? true : false}
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "var(--primary-bg-color)",
                              },
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={
                          <Radio
                            disabled={componentType === "view" ? true : false}
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "var(--primary-bg-color)",
                              },
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </>
              )}
            {projects.externalAccess === "restricted-link-access" && (
              <div
                className="authorized-users-section"
                style={{
                  marginTop: "40px",
                  width: "96.5%",
                  border: "1px dashed #ccc",
                  padding: "20px",
                  borderRadius: "8px",
                }}
              >
                <h3 className="section-title">Shared Access</h3>

                {componentType !== "view" ? (
                  <div className="authorized-users-table-container">
                    <table className="authorized-users-table">
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email ID</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {projects.authorizedExternalUsers &&
                          projects.authorizedExternalUsers.map((user, idx) => (
                            <tr key={idx}>
                              <td>{user.firstName}</td>
                              <td>{user.lastName}</td>
                              <td>{user.emailId}</td>
                              <td>
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assests/img/newTrash.svg"
                                  }
                                  alt="delete"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleRemoveExternalUser(idx)}
                                />
                              </td>
                            </tr>
                          ))}
                        <tr>
                          <td>
                            <div className="input-cell-content">
                              <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                placeholder="First Name"
                                value={extUser.firstName}
                                onChange={(e) => {
                                  setExtUser({
                                    ...extUser,
                                    firstName: e.target.value,
                                  });
                                  setExtUserErrors({
                                    ...extUserErrors,
                                    firstName: "",
                                  });
                                }}
                                error={Boolean(extUserErrors.firstName)}
                                helperText={extUserErrors.firstName}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-cell-content">
                              <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                placeholder="Last Name"
                                value={extUser.lastName}
                                onChange={(e) => {
                                  setExtUser({
                                    ...extUser,
                                    lastName: e.target.value,
                                  });
                                  setExtUserErrors({
                                    ...extUserErrors,
                                    lastName: "",
                                  });
                                }}
                                error={Boolean(extUserErrors.lastName)}
                                helperText={extUserErrors.lastName}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-cell-content">
                              <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                placeholder="Email ID"
                                value={extUser.emailId}
                                onChange={(e) => {
                                  setExtUser({
                                    ...extUser,
                                    emailId: e.target.value,
                                  });
                                  setExtUserErrors({
                                    ...extUserErrors,
                                    emailId: "",
                                  });
                                }}
                                error={Boolean(extUserErrors.emailId)}
                                helperText={extUserErrors.emailId}
                              />
                            </div>
                          </td>
                          <td
                            className="action-cell"
                            style={{ marginTop: "10px" }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assests/img/newTrash.svg"
                              }
                              alt="delete"
                              style={{ cursor: "pointer" }}
                              onClick={handleClearExternalUserInput}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                      <span
                        onClick={handleAddExternalUser}
                        style={{
                          color: "#333",
                          fontWeight: "500",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        Add New Row
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="authorized-users-table-container">
                    <table className="authorized-users-table">
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {projects.authorizedExternalUsers &&
                          projects.authorizedExternalUsers.map((user, idx) => (
                            <tr key={idx}>
                              <td>{user.firstName}</td>
                              <td>{user.lastName}</td>
                              <td>{user.emailId}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
            <div
                className="authorized-users-section"
                style={{
                  marginTop: "40px",
                  width: "96.5%",
                  border: "1px dashed #ccc",
                  padding: "20px",
                  borderRadius: "8px",
                }}
              >
                <h3 className="section-title">Selected Applicant Status</h3>
                <div className="statusDropdownContainer">
                  <div
                    className="statusMultipleSelectContainer"
                    style={{ marginTop: "15px" }}
                  >
                    <FormControl
                      fullWidth
                      variant="outlined"
                      error={Boolean(
                        formik.errors.selectedStatuses && formik.touched.selectedStatuses,
                      )}
                    >
                      <Select
                        className="statusSelectDropdown"
                        disabled={componentType === "view"}
                        multiple
                        displayEmpty
                        value={selectedStatuses}
                        onChange={(e) => {
                          const value = e.target.value;
                          const selectedArray = typeof value === "string" ? value.split(",") : value;
                          let finalSelected = [];
                          if (selectedArray.includes("all")) {
                            if (selectedStatuses.length === candidateStatusValues.length) {
                              finalSelected = [];
                            } else {
                              finalSelected = candidateStatusValues.map((item) =>
                                String(item.internal)
                              );
                            }
                          } else {
                            finalSelected = selectedArray.map(String);
                          }
                          setSelectedStatuses(finalSelected);
                          formik.setFieldValue("selectedStatuses", finalSelected, true);
                          formik.setFieldTouched("selectedStatuses", true, false);
                        }}
                        renderValue={(selected) => {
                          if (!selected || selected.length === 0) {
                            return "";
                          }

                          return candidateStatusValues
                            .filter((item) => selected.includes(String(item.internal)))
                            .map((item) => item.internal) // or item.name if available
                            .join(", ");
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: "calc(100vh - 450px)",
                            },
                          },
                          sx: {
                            "& .MuiMenuItem-root": {
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "100%",
                              padding: "8px 16px",
                            },
                          },
                        }}
                      >
                        {candidateStatusValues.length > 0 && (
                          <MenuItem value="all">
                            <Checkbox
                              checked={
                                candidateStatusValues.length > 0 &&
                                selectedStatuses.length === candidateStatusValues.length
                              }
                              indeterminate={
                                selectedStatuses.length > 0 &&
                                selectedStatuses.length < candidateStatusValues.length
                              }
                            />
                            <ListItemText primary="Select All" />
                          </MenuItem>
                        )}
                        {candidateStatusValues.map((statusItem, idx) => {
                          const statusLabel = statusItem.internal || statusItem;
                          return (
                            <MenuItem key={idx} value={statusLabel}>
                              <Checkbox
                                checked={selectedStatuses.includes(statusLabel)}
                              />
                              <ListItemText primary={statusLabel} />
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {formik.errors.selectedStatuses &&
                        formik.touched.selectedStatuses && (
                          <FormHelperText className="text-danger">
                            {formik.errors.selectedStatuses}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </div>
                </div>
              </div>

            <div
              className="project-link-section"
              style={{
                marginTop: "40px",
                backgroundColor: "#f5f5f5",
                padding: "16px 20px 24px 20px",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                width: "96.5%",
              }}
            >
              <h4
                style={{
                  margin: "0 0 16px 0",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                You can preview the changes and access Project link using the
                URL below
              </h4>

              <div style={{ position: "relative", marginTop: "10px" }}>
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    left: "12px",
                    backgroundColor: "#f5f5f5",
                    padding: "0 4px",
                    fontSize: "11px",
                    color: "#666",
                    zIndex: 1,
                    fontWeight: 500,
                  }}
                >
                  Talent Portal URL
                </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    backgroundColor: "transparent",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      padding: "12px 14px",
                      fontSize: "18px",
                      color: "#000000",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      fontFamily: "Roboto",
                      fontWeight: "400",
                    }}
                  >
                    {`${process.env.REACT_APP_JOBBOARD_PORTAL_URL}${projects?.token || ""}`}
                  </div>
                  <Button
                    onClick={handleCopyLink}
                    sx={{
                      minWidth: "auto",
                      padding: "12px",
                      color: "#555",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <ContentCopyIcon sx={{ fontSize: "20px" }} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProjectsComponent;

const statusArray = [
  { id: 0, name: "Inactive", title: "Inactive" },
  { id: 1, name: "Active", title: "Active" },
];

const internalVisibilityArray = [
  { id: 1, name: "private", title: "Private" },
  { id: 2, name: "restricted", title: "Restricted" },
  { id: 3, name: "organization-wide", title: "Organization - wide" },
];

const externalAccessArray = [
  { id: 1, name: "disabled", title: "Disabled" },
  { id: 2, name: "open-link-access", title: "Open Link Access" },
  {
    id: 3,
    name: "restricted-link-access",
    title: "Restricted Link Access (Email Whitelist)",
  },
];
